import GoTrue from 'gotrue-js';
import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

window.auth = new GoTrue({
  APIUrl: 'https://hours.5hd.co/.netlify/identity',
  setCookie: true
});

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <p>
            Edit <code>src/App.js</code> and save to reload.
          </p>
          <a
            className="App-link"
            href="https://reactjs.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn React
          </a>
        </header>
      </div>
    );
  }
}

export default App;
